import { cn } from '@/utils/utils_client';
import * as RADIX__context_menu from '@radix-ui/react-context-menu';
import * as React from 'react';

export const UI_PRIMITIVE__context_menu_item = React.forwardRef<
  React.ElementRef<typeof RADIX__context_menu.Item>,
  React.ComponentPropsWithoutRef<typeof RADIX__context_menu.Item> & {
    inset?: boolean;
  }
>(({ className, inset, ...props }, ref) => (
  <RADIX__context_menu.Item
    ref={ref}
    className={cn(
      'relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-xs outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 h-6 text-component-item-foreground hover:bg-component',
      inset && 'pl-8',
      className,
    )}
    {...props}
  />
));
UI_PRIMITIVE__context_menu_item.displayName = RADIX__context_menu.Item.displayName;
